var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoBrick({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 298,
    height: 71,
    viewBox: "0 0 298 71",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_201_1471)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M178.35 17.99L207.78 1",
    stroke: "#767676",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "3 3 3 3 3 3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.07 34.63L237.49 17.64",
    stroke: "#767676",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "3 3 3 3 3 3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.59 17.99L207.78 34.97",
    stroke: "#767676",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "3 3 3 3 3 3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.52 52.01L207.71 69",
    stroke: "#767676",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "3 3 3 3 3 3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.01 1L237.49 17.64",
    stroke: "#767676",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "3 3 3 3 3 3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.78 34.97V68.95",
    stroke: "#767676",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "3 3 3 3 3 3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.35 17.99L178.59 52.01",
    stroke: "#767676",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "3 3 3 3 3 3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.44 51.96L207.78 68.95",
    stroke: "#767676",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "3 3 3 3 3 3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.44 17.99V51.96",
    stroke: "#767676",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "3 3 3 3 3 3"
  })), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M237.56 18.21L266.98 1.21997",
    stroke: "#767676",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "3 3 3 3 3 3"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M267.27 34.85L296.69 17.86",
    stroke: "#767676",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "3 3 3 3 3 3"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M237.79 18.21L266.98 35.2",
    stroke: "#767676",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "3 3 3 3 3 3"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M237.73 52.24L266.91 69.22",
    stroke: "#767676",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "3 3 3 3 3 3"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M267.22 1.21997L296.69 17.86",
    stroke: "#767676",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "3 3 3 3 3 3"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M266.98 35.2V69.1699",
    stroke: "#767676",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "3 3 3 3 3 3"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M296.64 52.1801L266.98 69.1701",
    stroke: "#767676",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "3 3 3 3 3 3"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M296.64 18.21V52.18",
    stroke: "#767676",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "2 2 2 2 2 2"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M119.29 18.2L148.71 1.20996",
    stroke: "#767676",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "3 3 3 3 3 3"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M149 34.84L178.42 17.85",
    stroke: "#767676",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "3 3 3 3 3 3"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M119.53 18.2L148.71 35.1899",
    stroke: "#767676",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "3 3 3 3 3 3"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M119.46 52.23L148.64 69.21",
    stroke: "#767676",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "3 3 3 3 3 3"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M148.95 1.20996L178.42 17.85",
    stroke: "#767676",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "3 3 3 3 3 3"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M148.71 35.1899V69.1599",
    stroke: "#767676",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "3 3 3 3 3 3"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M178.37 52.17L148.71 69.16",
    stroke: "#767676",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "3 3 3 3 3 3"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M60.21 18.5699L61.51 17.8199",
    stroke: "#767676",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.95 16.41L72.48 11.48",
    stroke: "#767676",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "2.82 2.82 2.82 2.82"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.7 10.7799L87.12 3.03992",
    stroke: "#767676",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "2.82 2.82 2.82 2.82 2.82 2.82"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.3301 2.32996L89.6301 1.57996",
    stroke: "#767676",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M89.9199 35.21L91.2199 34.46",
    stroke: "#767676",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.6599 33.05L102.2 28.12",
    stroke: "#767676",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "2.82 2.82 2.82 2.82"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.42 27.4199L116.83 19.6799",
    stroke: "#767676",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "2.82 2.82 2.82 2.82 2.82 2.82"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.05 18.97L119.35 18.22",
    stroke: "#767676",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M60.45 18.5699L61.75 19.3199",
    stroke: "#767676",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.1599 20.73L72.6199 25.66",
    stroke: "#767676",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "2.8 2.8 2.8 2.8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.8298 26.36L87.1298 34.1",
    stroke: "#767676",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "2.8 2.8 2.8 2.8 2.8 2.8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.3398 34.7999L89.6298 35.5599",
    stroke: "#767676",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M60.3799 52.6L61.6799 53.35",
    stroke: "#767676",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.0999 54.76L72.5599 59.68",
    stroke: "#767676",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "2.8 2.8 2.8 2.8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.7598 60.39L87.0598 68.12",
    stroke: "#767676",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "2.8 2.8 2.8 2.8 2.8 2.8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.2698 68.83L89.5598 69.58",
    stroke: "#767676",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M89.8701 1.57996L91.1801 2.31996",
    stroke: "#767676",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.6201 3.69995L102.17 8.51995",
    stroke: "#767676",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "2.8 2.8 2.8 2.8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.39 9.20996L116.82 16.8",
    stroke: "#767676",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "2.8 2.8 2.8 2.8 2.8 2.8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.04 17.49L119.35 18.22",
    stroke: "#767676",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M89.6299 35.5601V37.0601",
    stroke: "#767676",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.6299 39.8701V49.7301",
    stroke: "#767676",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "2.82 2.82 2.82 2.82"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.6299 51.13V66.62",
    stroke: "#767676",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "2.82 2.82 2.82 2.82 2.82 2.82"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.6299 68.03V69.53",
    stroke: "#767676",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M60.21 18.5699L60.22 20.0699",
    stroke: "#767676",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.24 22.8899L60.31 32.7599",
    stroke: "#767676",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "2.82 2.82 2.82 2.82"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.3201 34.1699L60.4301 49.6799",
    stroke: "#767676",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "2.82 2.82 2.82 2.82 2.82 2.82"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.4399 51.09L60.4499 52.59",
    stroke: "#767676",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M119.29 52.54L117.99 53.29",
    stroke: "#767676",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.53 54.7001L106.92 59.6301",
    stroke: "#767676",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "2.83 2.83 2.83 2.83"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.69 60.3301L92.1699 68.0801",
    stroke: "#767676",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "2.83 2.83 2.83 2.83 2.83 2.83"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.9399 68.78L89.6299 69.53",
    stroke: "#767676",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M119.29 18.5699V20.0699",
    stroke: "#767676",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.29 22.8899V32.7399",
    stroke: "#767676",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "2.82 2.82 2.82 2.82"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.29 34.1499V49.6399",
    stroke: "#767676",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "2.82 2.82 2.82 2.82 2.82 2.82"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.29 51.0399V52.5399",
    stroke: "#767676",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M1.21997 18.57L30.65 1.58997",
    stroke: "#767676",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "3 3 3 3 3 3"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M30.71 35.4199L60.14 18.4399",
    stroke: "#767676",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "3 3 3 3 3 3"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M1.23999 18.78L30.42 35.77",
    stroke: "#767676",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "3 3 3 3 3 3"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M1.16992 52.8101L30.3499 69.8001",
    stroke: "#767676",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "3 3 3 3 3 3"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M30.6599 1.80005L60.1399 18.4401",
    stroke: "#767676",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "3 3 3 3 3 3"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M30.4199 35.77V69.74",
    stroke: "#767676",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "3 3 3 3 3 3"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M1 18.78L1.24 52.81",
    stroke: "#767676",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "3 3 3 3 3 3"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M60.0799 52.76L30.4199 69.74",
    stroke: "#767676",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "3 3 3 3 3 3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.33 68.8V34.83",
    stroke: "#00A4AA",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.33 34.83V68.8",
    stroke: "#00A4AA",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.66 52.95L296.48 20.42",
    stroke: "#00A4AA",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.38 51.17L296.62 52.03",
    stroke: "#00A4AA",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.94 34.7L237.36 17.71",
    stroke: "#00A4AA",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.94 34.7V68.6699L237.36 51.6899",
    stroke: "#00A4AA",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.6 35.08L178.02 18.09",
    stroke: "#2A96B6",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.6 69.0499L178.02 52.0699",
    stroke: "#2A96B6",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.85 26.33V60.3",
    stroke: "#2A96B6",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.8701 35.33L119.29 18.34",
    stroke: "#1F6EA9",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.8699 35.33L119.29 18.34V34.43L89.6799 52.4L119.29 52.31",
    stroke: "#1F6EA9",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.8701 69.3V35.33",
    stroke: "#1F6EA9",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.8701 35.33V69.3",
    stroke: "#1F6EA9",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.6399 35.34L60.0699 18.35",
    stroke: "#1A529D",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.6399 69.8099L60.0699 52.8199",
    stroke: "#1A529D",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.6399 51.98L53.9799 38.51",
    stroke: "#1A529D",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.98 38.51L60.07 30.78",
    stroke: "#1A529D",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.98 38.51L60.07 41.41",
    stroke: "#1A529D",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.6399 35.34V69.81",
    stroke: "#1A529D",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.0701 18.7V30.78",
    stroke: "#1A529D",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.0701 41.41V52.68",
    stroke: "#1A529D",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_201_1471"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 297.69,
    height: 70.81,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoBrick);
export default __webpack_public_path__ + "static/media/logo_brick.0954b32b7c293dc90bdf1613473ce68d.svg";
export { ForwardRef as ReactComponent };